import axios from "axios";
import API from "../api";

const token = localStorage.getItem("auth") === null ? null : JSON.parse(localStorage.getItem("auth")).accessToken
const userId = localStorage.getItem("auth") === null ? null : JSON.parse(localStorage.getItem("auth")).user?.userId
const language = localStorage.getItem("lang") === null ? "tr" : localStorage.getItem("lang")
const header = { headers: { "Authorization": `Bearer ${token}`, "Accept-Language": language } }

async function refreshTokenRequest() {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (!auth) return null;
    try {
        const response = await axios.post(API.REFRESH, {
            accessToken: auth.accessToken,
            refreshToken: auth.refreshToken
        });
        localStorage.setItem("auth", JSON.stringify(response.data));
        return response.data.accessToken;
    } catch (error) {
        return null;
    }
}

axios.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && error.response.status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;
            const newAccessToken = await refreshTokenRequest();
            if (newAccessToken) {
                originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
                return axios(originalRequest);
            }
        }
        return Promise.reject(error);
    }
);

export function LoginService(userName, password) {
    return axios.post(API.LOGIN, { "userName": userName, "password": password }, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ResetPassordService(mail) {
    return axios.get(API.RESET_PASSWORD, { "mail": mail }, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}


// Content

export function ContentGet() {
    return axios.get(API.CONTENT_GET, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ContentUpdate(file, footerText, footerText2, bannerText, bannerText2, bannerText3, showcaseText, showcaseText2, showcaseText3, specialField1, specialField2, specialField3, specialField4, specialField5, specialField6) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (footerText !== undefined) formData.append("FooterText", JSON.stringify(footerText))
    else formData.append("FooterText", JSON.stringify({}))
    if (footerText2 !== undefined) formData.append("FooterText2", JSON.stringify(footerText2))
    else formData.append("FooterText2", JSON.stringify({}))
    if (bannerText !== undefined) formData.append("BannerText", JSON.stringify(bannerText))
    else formData.append("BannerText", JSON.stringify({}))
    if (bannerText2 !== undefined) formData.append("BannerText2", JSON.stringify(bannerText2))
    else formData.append("BannerText2", JSON.stringify({}))
    if (bannerText3 !== undefined) formData.append("BannerText3", JSON.stringify(bannerText3))
    else formData.append("BannerText3", JSON.stringify({}))
    if (showcaseText !== undefined) formData.append("ShowcaseText", JSON.stringify(showcaseText))
    else formData.append("ShowcaseText", JSON.stringify({}))
    if (showcaseText2 !== undefined) formData.append("ShowcaseText2", JSON.stringify(showcaseText2))
    else formData.append("ShowcaseText2", JSON.stringify({}))
    if (showcaseText3 !== undefined) formData.append("ShowcaseText3", JSON.stringify(showcaseText3))
    else formData.append("ShowcaseText3", JSON.stringify({}))
    formData.append("SloganText", JSON.stringify({}))
    formData.append("Slogan2Text", JSON.stringify({}))
    formData.append("Slogan3Text", JSON.stringify({}))
    formData.append("SliderText", JSON.stringify({}))
    formData.append("BulletinText", JSON.stringify({}))
    formData.append("BulletinText2", JSON.stringify({}))
    formData.append("HeaderText", JSON.stringify({}))
    formData.append("HeaderText2", JSON.stringify({}))
    formData.append("OfferedText", JSON.stringify({}))
    formData.append("OfferedText2", JSON.stringify({}))
    formData.append("Title1", JSON.stringify({}))
    formData.append("Title2", JSON.stringify({}))
    formData.append("Title3", JSON.stringify({}))
    formData.append("Title4", JSON.stringify({}))
    formData.append("Title5", JSON.stringify({}))
    formData.append("Title6", JSON.stringify({}))
    if (specialField1 !== undefined) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    if (specialField2 !== undefined) formData.append("SpecialField2", JSON.stringify(specialField2))
    else formData.append("SpecialField2", JSON.stringify({}))
    if (specialField3 !== undefined) formData.append("SpecialField3", JSON.stringify(specialField3))
    else formData.append("SpecialField3", JSON.stringify({}))
    if (specialField4 !== undefined) formData.append("SpecialField4", JSON.stringify(specialField4))
    else formData.append("SpecialField4", JSON.stringify({}))
    if (specialField5 !== undefined) formData.append("SpecialField5", JSON.stringify(specialField5))
    else formData.append("SpecialField5", JSON.stringify({}))
    if (specialField6 !== undefined) formData.append("SpecialField6", JSON.stringify(specialField6))
    else formData.append("SpecialField6", JSON.stringify({}))
    formData.append("ID", 1)
    formData.append("UserId", userId)

    return axios.put(API.CONTENT_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Content END



// Contact

export function ContactGet() {
    return axios.get(API.CONTACT_GET, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ContactUpdate(file, country, city, district, address, company, companyDescription, phone, mail, location, fax, instagram, facebook, linkedin, youtube, specialField1, specialField2, specialField3, specialField4, specialField5) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (country !== undefined) formData.append("Country", JSON.stringify(country))
    else formData.append("Country", JSON.stringify({}))
    if (city !== undefined) formData.append("City", JSON.stringify(city))
    else formData.append("City", JSON.stringify({}))
    if (district !== undefined) formData.append("District", JSON.stringify(district))
    else formData.append("District", JSON.stringify({}))
    if (address !== undefined) formData.append("Address", JSON.stringify(address))
    else formData.append("Address", JSON.stringify({}))
    if (company !== undefined) formData.append("Company", JSON.stringify(company))
    else formData.append("Company", JSON.stringify({}))
    if (companyDescription !== undefined) formData.append("CompanyDescription", JSON.stringify(companyDescription))
    else formData.append("CompanyDescription", JSON.stringify({}))
    if (specialField1 !== undefined) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    if (specialField2 !== undefined) formData.append("SpecialField2", JSON.stringify(specialField2))
    else formData.append("SpecialField2", JSON.stringify({}))
    if (specialField3 !== undefined) formData.append("SpecialField3", JSON.stringify(specialField3))
    else formData.append("SpecialField3", JSON.stringify({}))
    if (specialField4 !== undefined) formData.append("SpecialField4", JSON.stringify(specialField4))
    else formData.append("SpecialField4", JSON.stringify({}))
    if (specialField5 !== undefined) formData.append("SpecialField5", JSON.stringify(specialField5))
    else formData.append("SpecialField5", JSON.stringify({}))
    formData.append("Phone", phone)
    formData.append("Mail", mail)
    if (location !== undefined) formData.append("Location", JSON.stringify(location))
    else formData.append("Location", JSON.stringify({}))
    formData.append("Fax", fax)
    formData.append("Mail", mail)
    formData.append("Instagram", instagram)
    formData.append("Facebook", facebook)
    formData.append("Linkedin", linkedin)
    formData.append("Youtube", youtube)
    formData.append("UserId", userId)

    return axios.put(API.CONTACT_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Contact END



// Document

export function DocumentGetAll() {
    return axios.get(API.DOCUMENT_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function DocumentGet(id) {
    return axios.get(`${API.DOCUMENT_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function DocumentCreate(file, title, slug, description, content, sort) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach((element, index) => {
            if (element) {
                console.log(element.file)
                formData.append("file", element);
            }
        });
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    formData.append("UserId", userId)

    return axios.post(API.DOCUMENT_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function DocumentUpdate(id, file, title, slug, description, content, sort) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.DOCUMENT_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function DocumentSort(id, sort) {
    return axios.put(`${API.DOCUMENT_SORT}/${id}/${sort}`, {}, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function DocumentDelete(id) {
    return axios.delete(`${API.DOCUMENT_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Document END



// Form

export function FormGetAllService() {
    return axios.get(API.FORM_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormGetService(id) {
    return axios.get(`${API.FORM_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormCreateService(file, title, slug, description, content, formGroupId) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Slug", JSON.stringify(slug))
    formData.append("Description", JSON.stringify(description))
    formData.append("Content", JSON.stringify(content))
    if (formGroupId !== 0) formData.append("FormGroupID", formGroupId)
    formData.append("UserId", userId)

    return axios.post(API.FORM_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormUpdateService(id, file, title, slug, description, content, formGroupId) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Slug", JSON.stringify(slug))
    formData.append("Description", JSON.stringify(description))
    formData.append("Content", JSON.stringify(content))
    if (formGroupId !== 0) formData.append("FormGroupID", formGroupId)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.FORM_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormDeleteService(id) {
    return axios.delete(`${API.FORM_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Form END



// FormElement

export function FormElementGetAllService() {
    return axios.get(API.FORM_ELEMENT_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormElementGetService(id) {
    return axios.get(`${API.FORM_ELEMENT_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormElementCreateService(file, element, type, formId) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Element", JSON.stringify(element))
    if (type !== undefined) formData.append("Type", type)
    if (formId !== 0) formData.append("FormID", formId)
    formData.append("UserId", userId)

    return axios.post(API.FORM_ELEMENT_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormElementUpdateService(id, file, element, type, formId) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Element", JSON.stringify(element))
    if (type !== undefined) formData.append("Type", type)
    if (formId !== 0) formData.append("FormID", formId)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.FORM_ELEMENT_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormElementDeleteService(id) {
    return axios.delete(`${API.FORM_ELEMENT_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// FormElement END



// FormGroup

export function FormGroupGetAllService() {
    return axios.get(API.FORM_GROUP_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormGroupGetService(id) {
    return axios.get(`${API.FORM_GROUP_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormGroupCreateService(file, title, slug, description, content, pageId) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Slug", JSON.stringify(slug))
    formData.append("Description", JSON.stringify(description))
    formData.append("Content", JSON.stringify(content))
    if (pageId !== 0) formData.append("PageID", pageId)
    formData.append("UserId", userId)

    return axios.post(API.FORM_GROUP_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormGroupUpdateService(id, file, title, slug, description, content, pageId) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Slug", JSON.stringify(slug))
    formData.append("Description", JSON.stringify(description))
    formData.append("Content", JSON.stringify(content))
    if (pageId !== 0) formData.append("PageID", pageId)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.FORM_GROUP_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function FormGroupDeleteService(id) {
    return axios.delete(`${API.FORM_GROUP_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// FormGroup END


// Language

export function LanguageGetAllService() {
    return axios.get(API.LANGUAGE_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function LanguageGetService(id) {
    return axios.get(`${API.LANGUAGE_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function LanguageCreateService(file, lang, code, zipCode) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Lang", JSON.stringify(lang))
    formData.append("Code", code)
    formData.append("ZipCode", zipCode)
    formData.append("UserId", userId)

    return axios.post(API.LANGUAGE_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function LanguageUpdateService(id, file, lang, code, zipCode) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Lang", JSON.stringify(lang))
    formData.append("Code", code)
    formData.append("ZipCode", zipCode)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.LANGUAGE_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function LanguageDeleteService(id) {
    return axios.delete(`${API.LANGUAGE_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Language END



// Log

export function LogGetAll(search, pageNumber, pageSize) {
    return axios.get(`${API.LOG_GETALL}?searchTerm=${search}&pageNumber=${pageNumber}&pageSize=${pageSize}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function LogGet(id) {
    return axios.get(`${API.LOG_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function LogDelete(id) {
    return axios.delete(`${API.LOG_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Log END



// Menu

export function MenuGetAllService() {
    return axios.get(API.MENU_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuGetAllByGroupService(id) {
    return axios.get(`${API.MENU_GETALLBYGROUP}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuGetService(id) {
    return axios.get(`${API.MENU_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuCreateService(file, title, slug, parentMenuId, menuGroupId, sort, specialField1) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element && element.file) {
                formData.append("file", element.file)
            }
        });
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Slug", JSON.stringify(slug))
    if (menuGroupId !== 0 && menuGroupId !== undefined) formData.append("MenuGroupID", menuGroupId)
    if (parentMenuId !== 0 && parentMenuId !== undefined) formData.append("ParentMenuId", parentMenuId)
    if (sort !== undefined) formData.append("Sort", sort)
    if (specialField1 !== undefined && specialField1 !== null) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("UserId", userId)

    return axios.post(API.MENU_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuUpdateService(id, file, title, slug, parentMenuId, menuGroupId, sort, filesToKeep, specialField1) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element && element.file) {
                formData.append("file", element.file)
            }
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Slug", JSON.stringify(slug))
    if (menuGroupId !== 0 && menuGroupId !== undefined) formData.append("MenuGroupID", menuGroupId)
    if (parentMenuId !== 0 && parentMenuId !== undefined && parentMenuId !== null) formData.append("ParentMenuId", parentMenuId)
    if (sort !== undefined) formData.append("Sort", sort)
    if (specialField1 !== undefined && specialField1 !== null) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.MENU_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuSortService(id, sort) {
    return axios.put(`${API.MENU_SORT}/${id}/${sort}`, {}, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuDeleteService(id) {
    return axios.delete(`${API.MENU_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Menu END


// MenuGroup

export function MenuGroupGetAllService() {
    return axios.get(API.MENUGROUP_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuGroupGetService(id) {
    return axios.get(`${API.MENUGROUP_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuGroupCreateService(file, title, description, content) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Description", JSON.stringify(description))
    formData.append("Content", JSON.stringify(content))
    formData.append("UserId", userId)

    return axios.post(API.MENUGROUP_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuGroupUpdateService(id, file, title, description, content, filesToKeep) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    formData.append("Title", JSON.stringify(title))
    formData.append("Description", JSON.stringify(description))
    formData.append("Content", JSON.stringify(content))
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.MENUGROUP_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function MenuGroupDeleteService(id) {
    return axios.delete(`${API.MENUGROUP_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// MenuGroup END


// Module

export function ModuleGetAllService() {
    return axios.get(API.MODULE_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleGetService(id) {
    return axios.get(`${API.MODULE_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleGetByPageService(id) {
    return axios.get(`${API.MODULE_GETALLBYPAGE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleGetSlugService(slug) {
    return axios.get(`${API.MODULE_GETALL}/${slug}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleCreateService(file, filesLang, filesTitle, showcaseID, pageId, title, slug, description, content, specialField1) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (filesLang && Array.isArray(filesLang) && filesLang.length > 0) {
        filesLang.forEach(element => {
            if (element) { formData.append("FilesLang", JSON.stringify(element)) }
            else formData.append("FilesLang", JSON.stringify({}))
        });
    }
    if (filesTitle && Array.isArray(filesTitle) && filesTitle.length > 0) {
        filesTitle.forEach(element => {
            if (element) { formData.append("FilesTitle", JSON.stringify(element)) }
            else formData.append("FilesTitle", JSON.stringify({}))
        });
    }
    if (title !== null && title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== null && slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== null && description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== null && content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (showcaseID !== null && showcaseID !== undefined) formData.append("ShowcaseID", showcaseID)
    if (specialField1 !== null && specialField1 !== undefined) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("SpecialField4", JSON.stringify({}))
    formData.append("SpecialField5", JSON.stringify({}))
    formData.append("SpecialField6", JSON.stringify({}))
    if (pageId !== null && pageId !== undefined) formData.append("PageID", pageId)
    formData.append("UserId", userId)

    return axios.post(API.MODULE_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleUpdateService(id, file, filesLang, filesTitle, showcaseID, pageId, title, slug, description, content, specialField1, filesToKeep) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (filesLang && Array.isArray(filesLang) && filesLang.length > 0) {
        filesLang.forEach(element => {
            if (element) { formData.append("FilesLang", JSON.stringify(element)) }
            else formData.append("FilesLang", JSON.stringify({}))
        });
    }
    if (filesTitle && Array.isArray(filesTitle) && filesTitle.length > 0) {
        filesTitle.forEach(element => {
            if (element) { formData.append("FilesTitle", JSON.stringify(element)) }
            else formData.append("FilesTitle", JSON.stringify({}))
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    if (title !== null && title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== null && slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== null && description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== null && content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (showcaseID !== null && showcaseID !== undefined) formData.append("ShowcaseID", showcaseID)
    if (specialField1 !== null && specialField1 !== undefined) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("SpecialField4", JSON.stringify({}))
    formData.append("SpecialField5", JSON.stringify({}))
    formData.append("SpecialField6", JSON.stringify({}))
    if (pageId !== null && pageId !== undefined) formData.append("PageID", pageId)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.MODULE_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleSortService(id, sort) {
    return axios.put(`${API.MODULE_SORT}/${id}/${sort}`, {}, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleDeleteService(id) {
    return axios.delete(`${API.MODULE_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Module END


// ModuleField

export function ModuleFieldGetAllService() {
    return axios.get(API.MODULE_FIELD_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleFieldGetService(id) {
    return axios.get(`${API.MODULE_FIELD_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleFieldGetSlugService(slug) {
    return axios.get(`${API.MODULE_FIELD_GETALL}/${slug}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleFieldCreateService(file, moduleId, name) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("FieldName", JSON.stringify(name))
    formData.append("Slug", JSON.stringify({}))
    formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("SpecialField4", JSON.stringify({}))
    formData.append("SpecialField5", JSON.stringify({}))
    formData.append("ModuleId", moduleId)
    formData.append("UserId", userId)

    return axios.post(API.MODULE_FIELD_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleFieldUpdateService(id, file, moduleId, name) {
    const formData = new FormData()
    console.log(file)
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    formData.append("FieldName", JSON.stringify(name))
    formData.append("Slug", JSON.stringify({}))
    formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("SpecialField4", JSON.stringify({}))
    formData.append("SpecialField5", JSON.stringify({}))
    formData.append("ModuleId", moduleId)
    formData.append("ID", id)
    formData.append("UserId", userId)
    console.log(formData.get("file"))

    return axios.put(API.MODULE_FIELD_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ModuleFieldDeleteService(id) {
    return axios.delete(`${API.MODULE_FIELD_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// ModuleField END


// Page

export function PageGetAllService() {
    return axios.get(API.PAGE_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function PageGetService(id) {
    return axios.get(`${API.PAGE_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function PageGetSlugService(slug) {
    return axios.get(`${API.PAGE_GETSLUG}/${slug}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function PageCreateService(slug, title, description, formID, pageType) {
    const formData = new FormData()
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    formData.append("FilesLang", JSON.stringify([{}]))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (formID !== undefined && formID !== 0 && formID !== null) formData.append("FormID", formID)
    if (pageType !== undefined && pageType !== 0 && pageType !== null) formData.append("PageType", pageType)
    formData.append("Content", JSON.stringify({}))
    formData.append("UserId", userId)

    return axios.post(API.PAGE_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function PageUpdateService(id, slug, title, description, formID, pageType) {
    const formData = new FormData()
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    formData.append("FilesLang", JSON.stringify([{}]))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (formID !== undefined && formID !== 0 && formID !== null) formData.append("FormID", formID)
    if (pageType !== undefined && pageType !== 0 && pageType !== null) formData.append("PageType", pageType)
    formData.append("Content", JSON.stringify({}))
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.PAGE_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function PageDeleteService(id) {
    return axios.delete(`${API.PAGE_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Page END


// Product 

export function ProductGetAll() {
    return axios.get(API.PRODUCT_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ProductGet(id) {
    return axios.get(`${API.PRODUCT_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ProductCreate(file, slug, title, description, content, sort) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    formData.append("UserId", userId)

    return axios.post(API.PRODUCT_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ProductUpdate(id, file, slug, title, description, content, sort, filesToKeep) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.PRODUCT_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ProductDelete(id) {
    return axios.delete(`${API.PRODUCT_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ProductSort(id, sort) {
    return axios.put(`${API.PRODUCT_SORT}/${id}/${sort}`, {}, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Product END



// Seo

export function SeoGetAll() {
    return axios.get(API.SEO_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SeoGet(id) {
    return axios.get(`${API.SEO_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SeoGetSlug(slug) {
    return axios.get(`${API.SEO_GETSLUG}/${slug}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SeoCreate(file, title, slug, description, keywords, canonical, author) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (keywords !== undefined) formData.append("Keywords", JSON.stringify(keywords))
    else formData.append("Keywords", JSON.stringify({}))
    formData.append("Canonical", canonical)
    formData.append("Author", author)
    formData.append("UserId", userId)

    return axios.post(API.SEO_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SeoUpdate(id, file, title, slug, description, keywords, canonical, author) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (keywords !== undefined) formData.append("Keywords", JSON.stringify(keywords))
    else formData.append("Keywords", JSON.stringify({}))
    formData.append("Canonical", canonical)
    formData.append("Author", author)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.SEO_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SeoDelete(id) {
    return axios.delete(`${API.SEO_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Seo END



// Setting

export function SettingGet() {
    return axios.get(API.SETTING_GET, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SettingUpdate(siteName, file, darkLogo, background, background2, background3, background4) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach((element, index) => {
            if (element) {
                formData.append("file", element.file);
            }
        });
    }

    if (darkLogo && Array.isArray(darkLogo) && darkLogo.length > 0) {
        darkLogo.forEach((element, index) => {
            if (element) {
                formData.append("darkLogo", element.file);
            }
        });
    }
    if (siteName !== undefined) formData.append("SiteName", JSON.stringify(siteName))
    else formData.append("SiteName", JSON.stringify({}))
    formData.append("UserId", userId)

    return axios.put(API.SETTING_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Setting END



// Showcase

export function ShowcaseGetAll() {
    return axios.get(API.SHOWCASE_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseGetAllByAbout() {
    return axios.get(API.SHOWCASE_GETALLBYABOUT, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseGetAllByNews() {
    return axios.get(API.SHOWCASE_GETALLBYNEWS, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseGetAllByPage(id) {
    return axios.get(`${API.SHOWCASE_GETALLBYPAGE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseGetAllByProduct(id) {
    return axios.get(`${API.SHOWCASE_GETALLBYPRODUCT}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseGet(id) {
    return axios.get(`${API.SHOWCASE_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseCreate(file, filesLang, filesTitle, pageId, slug, title, description, content, sort, productId, isAbout, specialField1, isNews, lineCount) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element && typeof element !== "string") {
                formData.append("file", element)
            }
        });
    }
    if (filesLang && Array.isArray(filesLang) && filesLang.length > 0) {
        filesLang.forEach(element => {
            if (element) { formData.append("FilesLang", JSON.stringify(element)) }
            else formData.append("FilesLang", JSON.stringify({}))
        });
    }
    if (filesTitle && Array.isArray(filesTitle) && filesTitle.length > 0) {
        filesTitle.forEach(element => {
            if (element) { formData.append("FilesTitle", JSON.stringify(element)) }
            else formData.append("FilesTitle", JSON.stringify({}))
        });
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (specialField1 !== undefined) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("SpecialField4", JSON.stringify({}))
    formData.append("SpecialField5", JSON.stringify({}))
    formData.append("SpecialField6", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    if (pageId !== undefined) formData.append("PageID", pageId)
    if (isAbout !== undefined) formData.append("IsAbout", isAbout)
    if (isNews !== undefined) formData.append("IsNews", isNews)
    if (productId !== undefined && productId !== null && productId !== 0) formData.append("ProductID", productId)
    if (lineCount !== undefined && lineCount !== null) formData.append("LineCount", lineCount)
    formData.append("UserId", userId)

    return axios.post(API.SHOWCASE_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseUpdate(id, file, filesLang, filesTitle, pageId, slug, title, description, content, sort, productId, isAbout, specialField1, isNews, filesToKeep, lineCount) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element && typeof element !== "string") {
                formData.append("file", element)
            }
        });
    }
    if (filesLang && Array.isArray(filesLang) && filesLang.length > 0) {
        filesLang.forEach(element => {
            if (element) { formData.append("FilesLang", JSON.stringify(element)) }
            else formData.append("FilesLang", JSON.stringify({}))
        });
    }
    if (filesTitle && Array.isArray(filesTitle) && filesTitle.length > 0) {
        filesTitle.forEach(element => {
            if (element) { formData.append("FilesTitle", element) }
            else formData.append("FilesTitle", "")
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    if (specialField1 !== undefined) formData.append("SpecialField1", JSON.stringify(specialField1))
    else formData.append("SpecialField1", JSON.stringify({}))
    formData.append("SpecialField2", JSON.stringify({}))
    formData.append("SpecialField3", JSON.stringify({}))
    formData.append("SpecialField4", JSON.stringify({}))
    formData.append("SpecialField5", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    if (pageId !== undefined) formData.append("PageID", pageId)
    if (isAbout !== undefined) formData.append("IsAbout", isAbout)
    if (isNews !== undefined) formData.append("IsNews", isNews)
    if (productId !== undefined && productId !== null && productId !== 0) formData.append("ProductID", productId)
    if (lineCount !== undefined && lineCount !== null) formData.append("LineCount", lineCount)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.SHOWCASE_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseDesign(id, filesSort, filesCol, filesClassname, titleSort, titleCol, titleClassname, descriptionSort, descriptionCol, descriptionClassname, contentSort, contentCol, contentClassname, specialField1Sort, specialField1Col, specialField1Classname, specialField2Sort, specialField2Col, specialField2Classname, specialField3Sort, specialField3Col, specialField3Classname, specialField4Sort, specialField4Col, specialField4Classname, specialField5Sort, specialField5Col, specialField5Classname,) {
    const data = {
        "id": id,
        "filesSort": filesSort,
        "filesCol": filesCol,
        "filesClassname": filesClassname,
        "titleSort": titleSort,
        "titleCol": titleCol,
        "titleClassname": titleClassname,
        "descriptionSort": descriptionSort,
        "descriptionCol": descriptionCol,
        "descriptionClassname": descriptionClassname,
        "contentSort": contentSort,
        "contentCol": contentCol,
        "contentClassname": contentClassname,
        "specialField1Sort": specialField1Sort,
        "specialField1Col": specialField1Col,
        "specialField1Classname": specialField1Classname,
        "specialField2Sort": specialField2Sort,
        "specialField2Col": specialField2Col,
        "specialField2Classname": specialField2Classname,
        "specialField3Sort": specialField3Sort,
        "specialField3Col": specialField3Col,
        "specialField3Classname": specialField3Classname,
        "specialField4Sort": specialField4Sort,
        "specialField4Col": specialField4Col,
        "specialField4Classname": specialField4Classname,
        "specialField5Sort": specialField5Sort,
        "specialField5Col": specialField5Col,
        "specialField5Classname": specialField5Classname,
    }

    return axios.put(API.SHOWCASE_DESIGN, data, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseDelete(id) {
    return axios.delete(`${API.SHOWCASE_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function ShowcaseSort(id, sort) {
    return axios.put(`${API.SHOWCASE_SORT}/${id}/${sort}`, {}, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Showcase END



// Slider Group

export function SliderGroupGetAll() {
    return axios.get(API.SLIDERGROUP_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderGroupGet(id) {
    return axios.get(`${API.SLIDERGROUP_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderGroupCreate(file, title, description, content) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    formData.append("Slug", JSON.stringify({}))
    formData.append("UserId", userId)

    return axios.post(API.SLIDERGROUP_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderGroupUpdate(id, file, title, description, content, filesToKeep) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (description !== undefined) formData.append("Description", JSON.stringify(description))
    else formData.append("Description", JSON.stringify({}))
    if (content !== undefined) formData.append("Content", JSON.stringify(content))
    else formData.append("Content", JSON.stringify({}))
    formData.append("Slug", JSON.stringify({}))
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.SLIDERGROUP_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderGroupDelete(id) {
    return axios.delete(`${API.SLIDERGROUP_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Slider Group END


// Slider 

export function SliderGetAll() {
    return axios.get(API.SLIDER_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderGetAllByGroup(id) {
    return axios.get(`${API.SLIDER_GETALLBYGROUP}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderGet(id) {
    return axios.get(`${API.SLIDER_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderCreate(file, title, slug, sliderGroupId, sort) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    formData.append("Description", JSON.stringify({}))
    formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    if (sliderGroupId !== undefined && sliderGroupId !== 0) formData.append("SliderGroupID", sliderGroupId)
    formData.append("UserId", userId)

    return axios.post(API.SLIDER_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderUpdate(id, file, title, slug, sliderGroupId, sort, filesToKeep) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    formData.append("Description", JSON.stringify({}))
    formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    if (sliderGroupId !== undefined && sliderGroupId !== 0) formData.append("SliderGroupID", sliderGroupId)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.SLIDER_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderDelete(id) {
    return axios.delete(`${API.SLIDER_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderSort(id, sort) {
    return axios.put(`${API.SLIDER_SORT}/${id}/${sort}`, {}, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// Slider END


// SliderContent 

export function SliderContentGetAll() {
    return axios.get(API.SLIDERCONTENT_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderContentGetAllBySlider(id) {
    return axios.get(`${API.SLIDERCONTENT_GETALLBYSLIDER}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderContentGet(id) {
    return axios.get(`${API.SLIDERCONTENT_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderContentCreate(file, title, slug, sliderId, sort) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    formData.append("Description", JSON.stringify({}))
    formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    if (sliderId !== undefined && sliderId !== 0) formData.append("SliderID", sliderId)
    formData.append("UserId", userId)

    return axios.post(API.SLIDERCONTENT_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderContentUpdate(id, file, title, slug, sliderId, sort, filesToKeep) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element) {
                formData.append("file", element)
            }
        });
    }
    if (filesToKeep && Array.isArray(filesToKeep)) {
        formData.append("FilesToKeep", JSON.stringify(filesToKeep))
    }
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    formData.append("Description", JSON.stringify({}))
    formData.append("Content", JSON.stringify({}))
    if (sort !== undefined) formData.append("Sort", sort)
    if (sliderId !== undefined && sliderId !== 0) formData.append("SliderID", sliderId)
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.SLIDERCONTENT_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderContentDelete(id) {
    return axios.delete(`${API.SLIDERCONTENT_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SliderContentSort(id, sort) {
    return axios.put(`${API.SLIDERCONTENT_SORT}/${id}/${sort}`, {}, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// SliderContent END


// SocialMedia

export function SocialMediaGetAllService() {
    return axios.get(API.SOCIALMEDIA_GETALL, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SocialMediaGetService(id) {
    return axios.get(`${API.SOCIALMEDIA_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SocialMediaCreateService(file, title, slug) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element && element.file) {
                formData.append("file", element.file)
            }
        });
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    formData.append("Description", JSON.stringify({}))
    formData.append("Content", JSON.stringify({}))
    formData.append("UserId", userId)

    return axios.post(API.SOCIALMEDIA_CREATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SocialMediaUpdateService(id, file, title, slug) {
    const formData = new FormData()
    if (file && Array.isArray(file) && file.length > 0) {
        file.forEach(element => {
            if (element && element.file) {
                formData.append("file", element.file)
            }
        });
    }
    if (title !== undefined) formData.append("Title", JSON.stringify(title))
    else formData.append("Title", JSON.stringify({}))
    if (slug !== undefined) formData.append("Slug", JSON.stringify(slug))
    else formData.append("Slug", JSON.stringify({}))
    formData.append("Description", JSON.stringify({}))
    formData.append("Content", JSON.stringify({}))
    formData.append("ID", id)
    formData.append("UserId", userId)

    return axios.put(API.SOCIALMEDIA_UPDATE, formData, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function SocialMediaDeleteService(id) {
    return axios.delete(`${API.SOCIALMEDIA_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// SocialMedia END


// User

export function UserGetAll() {
    return axios.get(`${API.USER_GETALL}?searchTerm=&pageNumber=1&pageSize=100`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function UserGet(id) {
    return axios.get(`${API.USER_GET}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function UserCreate(firstName, lastName, userName, email, phoneNumber, password) {
    var roles = []
    roles.push("Admin")
    return axios.post(API.REGISTER, {
        "firstName": firstName,
        "lastName": lastName,
        "userName": userName,
        "email": email,
        "phoneNumber": phoneNumber,
        "password": password,
        "roles": roles
    }, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function UserUpdate(firstName, lastName, userName, email, phoneNumber) {
    return axios.put(API.USER_UPDATE, {
        "firstName": firstName,
        "lastName": lastName,
        "userName": userName,
        "email": email,
        "phoneNumber": phoneNumber
    }, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function UserChangePassword(id, currentPass, newPass) {
    return axios.put(`${API.USER_CHANGE_PASSWORD}/${id}`, {
        "currentPassword": currentPass,
        "newPassword": newPass
    }, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

export function UserDelete(id) {
    return axios.delete(`${API.USER_DELETE}/${id}`, header)
        .then(res => res.data).catch(er => { console.log(er.response.data); return er.response.data })
}

// User END